import useCasMutation, { IGenericMutationProps } from './useCasMutation';

type updateMutationProps = IGenericMutationProps & {
  url: string;
};

export default function useUpdateMutation({ url, ...rest }: updateMutationProps) {
  return useCasMutation({ method: 'put', url, ...rest });
}
